import { render, staticRenderFns } from "./ProofcheckForm.vue?vue&type=template&id=bce879cc&scoped=true&"
import script from "./ProofcheckForm.vue?vue&type=script&lang=ts&"
export * from "./ProofcheckForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProofcheckForm.vue?vue&type=style&index=0&id=bce879cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce879cc",
  null
  
)

export default component.exports